const GEO_CACHE_PREFIX = "geoJson_cache_";
const DIVISION_GEO_CACHE_PREFIX = "divisionGeoJson_cache_";
const CACHE_EXPIRY_MS = 24 * 60 * 60 * 1000;

const isExpiredCache = (rawValue) => {
  try {
    const parsed = JSON.parse(rawValue);
    if (!parsed?.timestamp) return true;
    return Date.now() - parsed.timestamp >= CACHE_EXPIRY_MS;
  } catch {
    return true;
  }
};

/**
 * Removes expired geo caches and other stale keys that slow localStorage over long sessions.
 * Safe to run on every app load — does not touch auth or active table caches.
 */
export const pruneStaleStorage = () => {
  try {
    const keysToRemove = [];

    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;

      if (
        key.startsWith(GEO_CACHE_PREFIX) ||
        key.startsWith(DIVISION_GEO_CACHE_PREFIX)
      ) {
        const value = localStorage.getItem(key);
        if (isExpiredCache(value)) {
          keysToRemove.push(key);
        }
      }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));

    const tabs = JSON.parse(localStorage.getItem("appTabs") || "[]");
    if (Array.isArray(tabs) && tabs.length > 10) {
      localStorage.setItem("appTabs", JSON.stringify(tabs.slice(-5)));
    }
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
};
